
<template>
  <v-overlay v-if="displayBool"
             :absolute="true"
             style="cursor: pointer;"
             @click.native="config && config.notcloseable ? (null): (displayBool = false)">

    <v-card :color="color">
      <v-list-item dense
                   class="px-2">
        <v-list-item-icon v-if="icon"
                          class="my-auto mr-3">
          <v-icon :size="small ? 25 : 30">{{icon}}</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="py-auto">
          <component :is="small ? 'h3' : 'h2' "
                     class="white--text"
                     v-text="$t(text)" />
        </v-list-item-content>
        <v-list-item-action class="my-auto ml-1" v-if="!(config &&config.notcloseable)">
          <v-btn @click="config && config.notcloseable ? (null): (displayBool = false)"
                 icon>
            <v-icon :size="small ? 25 : 30">mdi-close</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card>
  </v-overlay>
</template>


<script>
export default {
  name: "OverlayAlert",
  props: ["config"],
  components: {},

  data() {
    return {
      displayBool: true,
      color: null,
      icon: false,
      text: null,
      small: false,
    };
  },

  mounted() {
    this.showAlert();
  },

  methods: {
    showAlert() {
      this.displayBool = this.config ? true : false;
      this.color = this.config && this.config.color ? this.config.color : "primary";
      this.icon =
        this.config && this.config.icon
          ? this.config.icon
          : this.config && this.config.icon === false
          ? false
          : "mdi-alert";
      this.text = this.config && this.config.text ? this.config.text : "Alert";
      this.small = this.config && this.config.small ? this.config.small : false;
    },
  },

  computed: {},

  watch: {
    config: function () {
      this.showAlert();
    },
  },
};
</script>
